import { NgClass } from '@angular/common';
import { Component, Input, OnInit, OnDestroy, Renderer2 } from '@angular/core';

@Component({
  selector: 'aig-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: true,
  imports: [ NgClass ]
})
export class ModalComponent implements OnInit, OnDestroy {
  newInnerHeight: string;

  @Input() position: string = '';
  @Input() size: string = '';
  @Input() type: string = '';

  @Input() isToast: boolean = true;

  @Input() customMaxWidth: string = '';
  @Input() customWidth: string = '';

  public panelPositionClass: string = '';

  constructor(
    private _renderer: Renderer2
  ) {
    this.newInnerHeight = `${window.innerHeight*.9}px`;
  }

  ngOnInit(): void {
    this.setPanelPositionClass();

    this._renderer.setStyle(document.body, 'overflow-y', 'hidden');
  }

  ngOnDestroy(): void {
    this._renderer.removeStyle(document.body, 'overflow-y');
  }

  private setPanelPositionClass(): void {
    switch (this.position) {
      case 'right':
        this.panelPositionClass = 'c-panel--right';
        break;
      case 'left':
        this.panelPositionClass = 'c-panel--left';
        break;
      case 'center':
        this.panelPositionClass = 'c-modal--center';
        break;
      default:
        this.panelPositionClass = '';
        break;
    }
  }

}
